import { render, staticRenderFns } from "./FormDelete.vue?vue&type=template&id=3787f340"
import script from "./FormDelete.vue?vue&type=script&lang=js"
export * from "./FormDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports